var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroMoblie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 1024,
    viewBox: "0 0 720 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2930)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1024,
    fill: "#003A31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489,
    cy: 221,
    r: 181,
    fill: "#F3FF4D",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 460,
    cy: 385.5,
    rx: 181,
    ry: 181.5,
    fill: "#F3FF4D",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231,
    cy: 274.5,
    rx: 181,
    ry: 181.5,
    fill: "#F3FF4D",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 179,
    cy: 480.5,
    rx: 181,
    ry: 181.5,
    fill: "#F3FF4D",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 641,
    cy: 538.5,
    rx: 181,
    ry: 181.5,
    fill: "#F3FF4D",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 114.5,
    cy: 89,
    rx: 209.5,
    ry: 210,
    fill: "#F3FF4D",
    fillOpacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 538,
    r: 153,
    fill: "#F3FF4D",
    fillOpacity: 0.08
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroMoblie);
export default __webpack_public_path__ + "static/media/heroMoblie.b53c3122a746331adf351e40a3033a03.svg";
export { ForwardRef as ReactComponent };